import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { TextRupiah } from "../../Text";
import { connect } from "react-redux";
import {
  Button,
  Row,
  Col,
  Collapse,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  // Label,
  Card,
  CardText,
} from "reactstrap";
import classNames from "classnames";

import { convertToRupiah, getCloudImageUrl } from "../../../utils";
import { doPostApplyVoucher } from "../../../actions/paymentAction";
import FormFeedback from "../../Forms/FormFeedback";
import SwitchToggle from "../../Forms/SwitchToggle";
import ModalVoucherCode from "../../Modals/ModalVoucherCode";

import {
  BANKTRANSFER,
  CREDITCARD,
  KREDIVO,
  AKULAKU,
  FULLWALLET,
  VIRTUALACCOUNT,
  BCA_VA,
  ATOME,
  BCA_INSTALLMENTS,
  DEFAULT_CREDIT_CARD,
  DEFAULT_PAYMENT_METHOD,
  BCA_KLIK_PAY,
  BCA_ONEKLIK,
  BCA_CREDIT_CARD
} from "../../../constants/paymentMethods";
import styled from "styled-components";
import KredivoIcon from "../../../images/kredivo-icon.png";
import AtomeIcon from "../../../images/atome-icon.png";
import NextIcon from "../../../images/global-next-icon.png";
import plusButton from "../../../images/plus-button.png";
import UmbreImage from "../../../images/umbre-product.png";
import umbreCheck from "../../../images/correct.png";
import InputRadio from "../../../components/Forms/Input/Radio";
import CloseButton from "../../../images/close-button-white.png";

const DEFAULT_INSTALLMENT_TYPE = "30_days";
const VOUCHER_APPLIED_MSG = "Voucher successfully applied.";

const Text = styled.p`
  font-size: 0.65rem;
  font-weight: ${(props) => (props.header ? 700 : "normal")};
  margin-bottom: ${(props) => (props.header ? ".5rem" : "0rem")};
  font-style: ${(props) => (props.header ? "normal" : "italic")};
`;

class FormPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _error: null,
      _voucherValidated: null,
      _paymentType: props._paymentType,
      _paymentMethods: DEFAULT_PAYMENT_METHOD,
      openVoucherModal: false,
      selectedVoucherCode: null,
      isBcaOnly: false,
      enabledPayments: []
    };
    this.toggleVoucherModal = this.toggleVoucherModal.bind(this);
  }

  componentDidMount() {
    const setPayment = [];
    const { variant_payment_methods } = this.props.dataProductDetails;
    if (variant_payment_methods && variant_payment_methods.length > 0) {
      const dataPayments = this.state._paymentMethods.map((payments) => {
        var variantPaymentMethod = Object.assign({}, payments);
        variant_payment_methods.find((item) => {
          const isSetPayment = setPayment.includes(item.payment_method)
            ? setPayment
            : setPayment.push(item.payment_method);
          if (!setPayment.includes(payments.payment_method))
            variantPaymentMethod.active = false;
          else variantPaymentMethod.active = true;
        });
        return variantPaymentMethod;
      });
      const paymentType =
        setPayment.length && setPayment.includes(BCA_VA)
          ? BCA_VA
          : setPayment.length && setPayment.includes(BANKTRANSFER)
            ? BANKTRANSFER
            : setPayment.length
              ? setPayment[0]
              : null;
      this.setState(
        {
          _paymentMethods: dataPayments,
          _paymentType: paymentType,
        },
        () => {
          if (paymentType) {
            if (paymentType === FULLWALLET)
              this.props._handleWalletPaymentCheckedChange(
                !this.props.walletPayment,
                paymentType
              );
            else {
              this.props._setPaymentType(paymentType);
            }
          }
        }
      );
    }
  }

  _isDisabled = (value, product) => {
    return (
      parseInt(this.props._balanceUser) <
      parseInt(this.props._getTotalWithoutWallet())
    );
  };

  toggleVoucherModal = () => {
    this.setState({
      openVoucherModal: !this.state.openVoucherModal,
    });
  };

  handleSelectedVoucherCode = async (data) => {
    const dataVoucher = this.props.dataVoucher.data
    const enabledPayments = data && dataVoucher && dataVoucher.length > 0 ? dataVoucher.find(i => i.voucher_id == data.id).voucher.enabled_payments : []



    this.setState({
      selectedVoucherCode: data,
      enabledPayments
    })

    if(enabledPayments && enabledPayments.length > 0){
      this.props._handleBalanceUsage();
      this.props.handleSelectedVoucherCode(data)
      await this.props._setPaymentType(enabledPayments[0])
      this.props._handleWalletPaymentCheckedChange(false, enabledPayments[0])
      this.props._handleKickPointCheckedChange(false, enabledPayments[0])
    } else {
      this.props._handleBalanceUsage();
      this.props.handleSelectedVoucherCode(data)
      await this.props._setPaymentType(BCA_VA)
      this.props._handleWalletPaymentCheckedChange(false, BCA_VA)
      this.props._handleKickPointCheckedChange(false, BCA_VA)
    }
  }

  render() {
    const isIndonesian =
      this.props.dataAuth &&
      this.props.dataAuth.userdata &&
      this.props.dataAuth.userdata.country_code === "IDN";
    const productPromo = this.props._additionalProducts
      .filter((item) => item.price && item.isSelected)
      .map((item) => item.price)
      .reduce((a, b) => a + b, 0);

    const {enabledPayments} = this.state;

    const availableMethods = this.state._paymentMethods.map((item) => {
      if (this.state.isBcaOnly) {
        if (item.payment_method == DEFAULT_CREDIT_CARD || item.payment_method == CREDITCARD || item.payment_method === BCA_VA || item.payment_method === BCA_INSTALLMENTS) {
          // this.props._setPaymentType(DEFAULT_CREDIT_CARD);
          return {
            ...item,
            active: true
          };
        } return { ...item, active: false };
      } else if (this.state.selectedVoucherCode && this.state.selectedVoucherCode.code === 'ATOMEFREESHIP') {
        if (item.payment_method === ATOME) {
          return {
            ...item,
            active: true
          };
        }
        return { ...item, active: false };
      } else return item;
    });

    const subsidy_price =
      this.props.sell &&
      this.props.sell.subsidy_price &&
      this.props.sell.subsidy_price.toString();

    const totalAllUsageBalance = this.props.sellerCreditUsage + this.props.balanceUsage + this.props.kickPointsUsage;
    const remainingPayment = this.props._getTotal() - totalAllUsageBalance;
    const totalActiveBalance = this.props.sellerCredit + this.props._balanceUser;
    const remainingUseKickPoint = (this.props._getTotal() - (this.props.sellerCreditUsage + this.props.balanceUsage));
    return (
      <Form
        style={{ display: "flex", flexDirection: "column", padding: "0" }}
        className="form-shipping payment"
      >
        <ModalVoucherCode
          isOpen={this.props.openVoucherModal}
          onToggle={this.props.toggleVoucherModal}
          selectedVoucherCode={this.state.selectedVoucherCode}
          handleSelectedVoucherCode={this.handleSelectedVoucherCode}
          discount={this.props._discount}
          _handleClearVoucher={this.props._handleClearVoucher}
        />
        <div className="email-wrapper">
          <span>{this.props.dataAuth.email}</span>
        </div>
        <Row className="credit-method">
          <Col>
            <span className="title-credit">Use Credit</span>
          </Col>
        </Row>
        <div
          className={classNames("payment-method-wrapper", {
            balance: !this.state._paymentMethods.filter(
              (item) => item.active && item.payment_group === 3
            ).length || this.state.isBcaOnly
          })}
        >
          <IconWrapper onClick={this.props.onToggleBalanceInfo}>
            <i className="fa fa-info-circle" />
          </IconWrapper>
          <div className="use-credit-container">
            <SwitchToggle
              active={this.props.isCreditUse}
              disabled={totalActiveBalance == 0 || remainingPayment == 0 && !this.props.isCreditUse || this.state.isBcaOnly || (this.state.selectedVoucherCode)}
              onClick={() => this.props._handleWalletPaymentCheckedChange(!this.props.isCreditUse, this.state._paymentType)}
            />
            <div className="balance-info-wrapper">
              <span>Credit: {totalActiveBalance > 0 ? convertToRupiah(totalActiveBalance) : 0}</span>
              <div className="balance-amount-wrapper">
                <span className="balance-amount">{`Kick Credit: ${convertToRupiah(this.props._balanceUser)}`}</span>
                <span className="balance-amount">{`Seller Credit: ${convertToRupiah(this.props.sellerCredit)}`}</span>
              </div>
            </div>
          </div>
          <div className="use-credit-container">
            <SwitchToggle
              active={(this.props.isUseKickPoints && !this.state.selectedVoucherCode)}
              // disabled={this.props._getTotal() < totalActiveBalance || remainingUseKickPoint == 0 || this.props.kickPoints == 0 || this.state.isBcaOnly}
              disabled={this.props.kickPoints == 0 || remainingPayment == 0 && !this.props.isUseKickPoints || this.state.isBcaOnly || (this.state.selectedVoucherCode)}
              onClick={() => this.props._handleKickPointCheckedChange(!this.props.isUseKickPoints, this.state._paymentType)} />
            <div className="balance-info-wrapper">
              <span>Use Kick Points</span>
              <span style={{ fontFamily: 'Nunito Regular' }}>Balance: {convertToRupiah(this.props.kickPoints)}</span>
            </div>
          </div>
        </div>
        <Collapse
          className="collapse-container-kickwallet"
          isOpen={remainingPayment > 0}
        >
          <Row className="credit-method">
            <Col>
              <span className="title-credit">Payment Method</span>
            </Col>
          </Row>
          <div className="payment-method-wrapper">
            {availableMethods.map((item) => {
              const akulakuTitle = `Start from IDR. ${convertToRupiah(
                this.props.dataAkulaku.length &&
                this.props.dataAkulaku[this.props.dataAkulaku.length - 1]
                  .monthly_installment
              )} for 
                  ${this.props.dataAkulaku.length &&
                  this.props.dataAkulaku[this.props.dataAkulaku.length - 1]
                    .tenure
                  ? `${this.props.dataAkulaku.length &&
                  this.props.dataAkulaku[
                    this.props.dataAkulaku.length - 1
                  ].tenure} months`
                  : "next month"
                }.`;
              if (item.payment_group === 1 || item.payment_group === 4) {
                let checkIsEnabled = enabledPayments && enabledPayments.length > 0 && enabledPayments.find(i => i == item.payment_method)

                return (
                  <div>
                    <InputRadio
                      label={item.label}
                      creditCard={item.payment_method === DEFAULT_CREDIT_CARD}
                      bordered={[BANKTRANSFER, VIRTUALACCOUNT, BCA_ONEKLIK].includes(item.payment_method) || item.label === "Credit Card / Debit Card / Installments"}
                      title={
                        ![
                          BANKTRANSFER,
                          BCA_INSTALLMENTS,
                          DEFAULT_CREDIT_CARD,
                          CREDITCARD,
                          AKULAKU,
                          BCA_KLIK_PAY,
                          BCA_ONEKLIK,
                          BCA_CREDIT_CARD
                        ].includes(item.payment_method)
                          ? "Virtual Account"
                          : null
                      }
                      name="_paymentType"
                      active={
                        (item.active && isIndonesian && enabledPayments && enabledPayments.length <= 0) ||
                        (!isIndonesian && item.payment_method === DEFAULT_CREDIT_CARD) ||
                        (checkIsEnabled == item.payment_method && isIndonesian && enabledPayments && item.active && enabledPayments.length > 0)
                      }
                      value={item.payment_method}
                      checked={this.props._paymentType === item.payment_method}
                      onChange={this.props._handlePaymentTypeChange}
                      subTitle={
                        item.payment_method === BANKTRANSFER
                          ? "Payment verification manually. (Only office hours)."
                          : item.payment_method === AKULAKU
                            ? akulakuTitle
                            : "Payment verification automatically."
                      }
                    >
                      {item.label}
                    </InputRadio>
                  </div>
                );
              }
              return null;
            })}
            {isIndonesian
              ? availableMethods
                .filter((item) => item.payment_group === 2)
                .map((item) => {
                  let checkIsEnabled = enabledPayments && enabledPayments.length > 0 && enabledPayments.find(i => i == item.payment_method)
                  switch (item.payment_method) {
                    case "atome":
                      const { asking_price, total_subsidy } = this.props.sell;
                      const price = total_subsidy
                        ? parseInt(total_subsidy)
                        : parseInt(asking_price);

                      return (
                        <InputRadio
                          active={(item.active && enabledPayments && enabledPayments.length <= 0) || (item.active && checkIsEnabled && enabledPayments && enabledPayments.length > 0)}
                          name="_paymentType"
                          value={item.payment_method}
                          checked={
                            this.props._paymentType === item.payment_method
                          }
                          onChange={this.props._handlePaymentTypeChange}
                          renderSubTitle={() => {
                            return (
                              <Text style={{ marginLeft: "1.5rem" }}>
                                Buy with{" "}
                                <a href="https://www.atome.id/en-id">
                                  <KickImage
                                    style={{
                                      height: 10,
                                      marginTop: "-.2rem",
                                    }}
                                    alt="atome icon"
                                    src={AtomeIcon}
                                  />
                                </a>{" "}
                                  at IDR. {convertToRupiah(Math.ceil(price / 3))}
                                  /month.
                              </Text>
                            );
                          }}
                        >
                          {item.label}
                        </InputRadio>
                      );
                    case "kredivo":
                      return this.props._installmentsList.length ? (
                        <InputRadio
                          bordered
                          active={(item.active && enabledPayments && enabledPayments.length <= 0) || (item.active && checkIsEnabled && enabledPayments && enabledPayments.length > 0)}
                          name="_paymentType"
                          value={item.payment_method}
                          checked={
                            this.props._paymentType === item.payment_method
                          }
                          onChange={this.props._handlePaymentTypeChange}
                          // subTitle="Buy now, pay later."
                          subTitle={`Start from IDR. ${convertToRupiah(
                            this.props._installmentsList[
                              this.props._installmentsList.length - 1
                            ].monthly_installment
                          )} for ${this.props._installmentsList[
                            this.props._installmentsList.length - 1
                          ].tenure > 1
                            ? `${this.props._installmentsList[
                              this.props._installmentsList.length - 1
                            ].tenure
                            } months`
                            : "next month"
                            }.`}
                        >
                          {item.label}
                        </InputRadio>
                      ) : null;
                    case "akulaku":
                      return this.props.dataAkulaku.length ? (
                        <InputRadio
                          // bordered
                          name="_paymentType"
                          value={item.payment_method}
                          active={(item.active && enabledPayments && enabledPayments.length <= 0) || (item.active && checkIsEnabled && enabledPayments && enabledPayments.length > 0)}
                          checked={this.props._paymentType === item.payment_method}
                          onChange={this.props._handlePaymentTypeChange}
                          subTitle={`Start from IDR. ${convertToRupiah(this.props.dataAkulaku[this.props.dataAkulaku.length - 1].monthly_installment)} for ${this.props.dataAkulaku[this.props.dataAkulaku.length - 1].tenure ? `${this.props.dataAkulaku[this.props.dataAkulaku.length - 1].tenure} months` : 'next month'}.`}
                        >
                          {item.label}
                        </InputRadio>
                      ) : null
                    default:
                      return null;
                  }
                })
              : null}
            {isIndonesian && (
              <div>
                <Collapse isOpen={this.props._paymentType === KREDIVO}>
                  <Card className="card-kredivo type" style={{ padding: 15 }}>
                    <KickImage
                      src={KredivoIcon}
                      style={{ width: 60, margin: "10px auto" }}
                      alt="Buy Now, Pay Later with Kredivo"
                    />
                    <CardText className="text-center">
                      Pilih Tipe Kredivo Cicilan
                    </CardText>
                    {this.props._installmentsList.map((item, index) => {
                      return (
                        <div
                          className="payment-method-wrapper kredivo"
                          key={index}
                        >
                          <Row>
                            <Col>
                              <div className="radio">
                                <label>
                                  <input
                                    type="radio"
                                    name="_installmentsType"
                                    value={item.value}
                                    checked={
                                      this.props._installmentsType ===
                                      item.value
                                    }
                                    onChange={this.props._handleChange}
                                  />{" "}
                                  {item.label}
                                </label>
                              </div>
                            </Col>
                          </Row>
                          <Row className="kick-credit-box">
                            {item.value !== DEFAULT_INSTALLMENT_TYPE ? (
                              <Col className="kick-credit-check kredivo">
                                <p>{`mulai dari IDR. ${convertToRupiah(
                                  item.monthly_installment
                                )}/bulan.**`}</p>
                              </Col>
                            ) : null}
                          </Row>
                        </div>
                      );
                    })}
                    <small>
                      (**) Hanya baru dihitung berdasarkan harga barang, belum
                      termasuk biaya lainnya.
                    </small>
                  </Card>
                </Collapse>
              </div>
            )}
          </div>
        </Collapse>

        {/* <div className="voucher-wrapper">
          <div className="title-name">
            <p>Voucher Code</p>
          </div>
          <div
            className="voucher-right-content"
            onClick={this.toggleVoucherModal}
          >
            <div className="text-wrapper">
              <p>{this.state.selectedVoucherCode ? `${this.state.selectedVoucherCode.code}` : "Enter voucher code here"}</p>
            </div>
            <div className="image-wrapper">
              <KickImage src={NextIcon} alt="next-icon" />
            </div>
          </div>
          <ModalVoucherCode
            isOpen={this.state.openVoucherModal}
            onToggle={this.toggleVoucherModal}
            selectedVoucherCode={this.state.selectedVoucherCode}
            handleSelectedVoucherCode={this.handleSelectedVoucherCode}
            discount={this.props._discount}
            _handleClearVoucher={this.props._handleClearVoucher}
          />
        </div> */}

        {/* HARBOLKICK */}
        {/* <div className="voucher-wrapper">
          <div className="text-inside">
            <p>VOUCHER CODE</p>
          </div>
          <div className="text-inside">
            <InputGroup>
              <Input
                name="_voucherInput"
                value={this.props._voucherInput}
                onChange={this.props._handleChange}
                className={classNames("form-control__input--black-lighter", {
                  "is-invalid": this.props._hasError("_voucherInput"),
                  "is-valid": this.props._isValidVoucher
                })}
                style={{ marginBottom: 0, textTransform: "uppercase" }}
              />
              <InputGroupAddon addonType="append">
                <Button
                  className="check-button"
                  onClick={this.props._applyVoucher}
                >
                  CHECK
                </Button>
              </InputGroupAddon>
              <FormFeedback
                valid={this.props._isValidVoucher}
                errors={
                  this.props._error !== null
                    ? this.props._error.errors
                    : undefined
                }
                field="_voucherInput"
              >
                {VOUCHER_APPLIED_MSG}{" "}
                <a href="#" onClick={this.props._handleClearVoucher}>
                  <i className="fa fa-times"></i> Clear
                </a>
              </FormFeedback>
              {this.props._voucherInput === "KOPIGOODDAY" &&
                this.props._isValidVoucher && (
                  <span className="valid-feedback" style={{ color: "#4a4a4a" }}>
                    With this transaction user agrees to participate in a Good
                    Day exclusive raffle at Kick Avenue for free.
                  </span>
                )}
            </InputGroup>
          </div>
        </div> */}

        <Row className="additional-wrapper">
          {isIndonesian &&
            this.props._additionalProducts
              .filter(
                (item) =>
                  item.active &&
                  (item.visible === "*" ||
                    item.visible.includes(this.props.category))
              )
              .map((item, index) => {
                return (
                  <Col xs={12} md={6}>
                    <Row style={{ minHeight: "100%" }}>
                      <Col
                        xs={3}
                        md={4}
                        className={classNames("img-wrapper", {
                          clicked: item.isSelected,
                          disabled:
                            !this.props._umbreEnabled &&
                            item.name.toUpperCase() === "KAXUMBRE",
                        })}
                        onClick={() =>
                          this.props._handleAdditionalChange(
                            item,
                            !item.isSelected
                          )
                        }
                      >
                        {item.img_url ? (
                          <KickImage
                            src={getCloudImageUrl(item.img_url, 150)}
                            alt={item.displayName}
                            className="plus-button"
                            style={{ width: "100%" }}
                          />
                        ) : null}
                      </Col>
                      <Col
                        xs={9}
                        md={8}
                        style={{ display: "flex", flexDirection: "column" }}
                        className={classNames("add-product", {
                          clicked: item.isSelected,
                          disabled:
                            !this.props._umbreEnabled &&
                            item.name.toUpperCase() === "KAXUMBRE",
                        })}
                        onClick={() =>
                          this.props._handleAdditionalChange(
                            item,
                            !item.isSelected
                          )
                        }
                      >
                        <div className="text-wrapper" style={{ flex: 1 }}>
                          <p>
                            <b>{item.displayName}</b>
                          </p>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </div>
                        <div className="text-price">
                          <span>
                            IDR. {convertToRupiah(parseInt(item.price))}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                );
              })}
          {this.props._isPickGoodDay ? (
            <span style={{ color: "red", marginTop: "1rem" }}>
              Sorry, You can only pick maximum 2 good day package.
            </span>
          ) : null}
        </Row>
        <div className="checkout-summary">
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>Product Price</p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                {this.props._askingPriceStatus === "PRICE_UP" ? (
                  <span className="fa fa-angle-double-up text-success"></span>
                ) : this.props._askingPriceStatus === "PRICE_DOWN" ? (
                  <span className="fa fa-angle-double-down text-danger"></span>
                ) : null}{" "}
                <TextRupiah
                  prefix="IDR. "
                  value={
                    this.props._askingPrice &&
                    this.props._askingPrice.toString()
                  }
                />
              </p>
            </Col>
          </Row>
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>Shipping and Handling</p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                <TextRupiah
                  prefix="IDR. "
                  value={
                    this.props._shippingFee &&
                    this.props._shippingFee.toString()
                  }
                />
              </p>
            </Col>
          </Row>
          {
            this.props._getLayananPrice() > 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Admin Fee</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    prefix="IDR. "
                    value={this.props._getLayananPrice().toString()}
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.state.selectedVoucherCode && this.props._discount > 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>
                  Voucher{" "}
                  {this.state._voucherValidated === null
                    ? ""
                    : `(${this.state._voucherValidated.code})`}
                </p>
              </Col>
              <Col xs={6} className="col-item">
                {this.state.selectedVoucherCode
                  ? <p>
                    <TextRupiah
                      minus={this.props._discount != 0 ? "- " : ""}
                      value={
                        this.props._discount > 0 && this.props._discount.toString()
                      }
                      style={{ color: "red" }}
                    />
                  </p> : <p style={{ color: "red" }}>
                    0
                  </p>
                }
              </Col>
            </Row>
          }
          {
            productPromo > 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Additional Product</p>
              </Col>

              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    prefix="IDR. "
                    value={productPromo && productPromo.toString()}
                  />
                </p>
              </Col>
            </Row>
          }
          {
            subsidy_price > 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Discount (Automatically applied)</p>
              </Col>

              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    minus={
                      parseInt(subsidy_price) !== 0 &&
                        !isNaN(parseInt(subsidy_price))
                        ? "- "
                        : ""
                    }
                    value={subsidy_price ? subsidy_price : "0"}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.balanceUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Kick Credit Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isCreditUse && (this.props.balanceUsage > 0)}
                    minus={this.props.isCreditUse && (this.props.balanceUsage > 0) ? "- " : ""}
                    value={this.props.isCreditUse && this.props.balanceUsage ? this.props.balanceUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.sellerCreditUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Seller Credit Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isCreditUse && (this.props.sellerCreditUsage > 0)}
                    minus={this.props.isCreditUse && (this.props.sellerCreditUsage > 0) ? "- " : ""}
                    value={this.props.isCreditUse && this.props.sellerCreditUsage ? this.props.sellerCreditUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          {
            this.props.kickPointsUsage !== 0 && <Row className="row-item">
              <Col xs={6} className="col-item">
                <p>Kick Point Usage</p>
              </Col>
              <Col xs={6} className="col-item">
                <p>
                  <TextRupiah
                    // minus={this.props.isUseKickPoints && (this.props.kickPointsUsage > 0)}
                    minus={this.props.isUseKickPoints && (this.props.kickPointsUsage > 0) ? "- " : ""}
                    value={this.props.isUseKickPoints && this.props.kickPointsUsage > 0 ? this.props.kickPointsUsage.toString() : ""}
                    color="red"
                  />
                </p>
              </Col>
            </Row>
          }
          <Row className="row-item">
            <Col xs={6} className="col-item">
              <p>
                <span>TOTAL</span>
              </p>
            </Col>
            <Col xs={6} className="col-item">
              <p>
                <TextRupiah
                  prefix="IDR. "
                  value={remainingPayment > 0 ? remainingPayment.toString() : 0}
                />
              </p>
            </Col>
          </Row>
        </div>
      </Form >
    );
  }
}

const IconWrapper = styled.div`
  position: absolute;
  right: 10px;
  font-size: 18px;
  color: #159953;
  cursor: pointer;
  width: 30px;
  height: 30px;
`
const mapStateToProps = (state) => ({
  dataProductDetails: state.dataProduct.productDetails,
  dataCouriers: state.dataPostalCode.couriers,
  dataPayments: state.dataPayment,
  dataAkulaku: state.dataPayment.akulakuAvailableInstallment.data,
  dataAuth: state.dataAuth,
  dataVoucher: state.dataKickPoint.userVoucher,
});

const mapDispatchToProps = (dispatch) => ({
  applyVoucher: (payload) => dispatch(doPostApplyVoucher(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormPayment);